import React from "react";
import { Route, Redirect } from "react-router-dom";

export const ProtectedRoutes = (props) => {
    return (
        <Route path={props.path} render={() => {
            return localStorage.hasOwnProperty('CauseChatbotToken')
            ? <props.component {...props}></props.component>
            : <Redirect to={ '/' } />
        }} />
    )
}